import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { AxiosError, AxiosResponse } from "axios";

export type UseAxiosMutationOptions<
  TResponse = void,
  TVariables = void,
> = UseMutationOptions<AxiosResponse<TResponse>, AxiosError, TVariables>;

export const useAxiosMutation = <
  TResponse = void,
  TVariables = void,
>(
  params: UseAxiosMutationOptions<TResponse, TVariables>
) => useMutation<AxiosResponse<TResponse>, AxiosError, TVariables>(params);
